module.exports = __webpack_public_path__ + "media/images/result_sets/circles/9r8r3n6r-310ca296169f29609af361253bea8976.svg";